<template>
    <!--    <pre v-text="JSON.stringify(result, null, 4)" />-->
    <div class="Configurator">
        <Breadcrumbs
            :current="currentStep"
            :settings="settings"
            @stepChange="setStep($event)">
        </Breadcrumbs>
        <div class="Configurator-frame u-frameMd">
            <div class="Configurator-side" v-if="settings[currentStep].showSummary">
                <div class="Configurator-sideInner">
                    <SummaryPanel
                        :configuration="configuration"
                        :result="result"
                        :total="total"
                        :gift="gift"
                        :stepsLength="steps.length"
                        :currentStep="currentStep"
                    ></SummaryPanel>

                  <BaseAlert class="BaseAlert-minCena" v-if="total.minimumFinalPrice && total.totalPrice < total.minimumFinalPrice">
                    <small >Minimální objednávka je {{ formatPrice(total.minimumFinalPrice) }}. </small>
                  </BaseAlert>
                    <StepBar
                        :current="currentStep"
                        :settings="settings"
                        :total="total"
                        @stepChange="setStep($event)">
                    </StepBar>
                </div>
            </div>
            <div class="Configurator-content">
                <div class="Configurator-contentIntro" v-if="steps[currentStep].content"
                     v-html="steps[currentStep].content"></div>
                <SectionNav v-if="settings[currentStep].showSectionNav && configuration.zones"
                            :sections="configuration.zones"
                            :class="{'is-chosen': !settings[currentStep].valid}"
                ></SectionNav>
                <BaseAlert v-if="!settings[currentStep].valid && steps[currentStep].errorMessage">
                    {{ steps[currentStep].errorMessage }}
                    <small v-if="!$route.name.includes('realization-conf')">Pokud chcete kalkulaci jen pro konkrétní
                        službu, přejděte
                        <router-link
                            :to="{name: $route.name === 'garden-conf-whole' ? 'garden-conf-part' : 'maintenance-conf-part'}">
                            zde
                        </router-link>
                        .</small>
                    <small v-else-if="settings.length > 3 && currentStep === 0">Pokud vám nevyhovuje ani jeden z
                        nabízených balíčků, můžete si vše navolit sám
                        <router-link :to="{name: 'realization-conf-own'}">zde</router-link>
                        .</small>
                </BaseAlert>
                <BaseAlert class="BaseAlert-minCena" v-if="total.minimumFinalPrice && total.totalPrice < total.minimumFinalPrice">
                  <small >Minimální objednávka je {{ formatPrice(total.minimumFinalPrice) }}. </small>
                </BaseAlert>
                <EntryTypeFactory v-for="(entry, entryKey) of entries" :entry="entry" :configuratorId="id"
                                  :configuration="configuration" :gift="gift"
                                  :enabled="!entry.required && settings[currentStep].valid" class="ConfEntry"
                                  :class="{'is-chosen': !entry.required && !settings[currentStep].valid}">
                    <div class="ConfEntry-content">
                        <div class="ConfEntry-main">
                            <div :class="{'ConfEntry-gridView': entry.isGridView}">
                                <template v-for="field of entry.fields">
                                    <FieldsFactory :field="field" :packages="packages" class="ConfEntry-field" extended></FieldsFactory>
                                    <FieldsFactory f="subfield" v-for="subField of field.subFields" :field="subField" :packages="packages" class="ConfEntry-field"
                                                   v-if="!$route.name.includes('realization-conf')"></FieldsFactory>
                                </template>
                            </div>
                            <StyledText :text="entry.text" class="ConfEntry-text"></StyledText>
                            <PackageIncludes :items="entry.items" class="ConfEntry-items"></PackageIncludes>
                            <BaseNote v-if="entry.note">
                                <span v-html="entry.note" class="ConfEntry-note"></span>
                            </BaseNote>
                            <PackageIcon v-if="entry.packages" :packageId="entry.packages[entry.packages.length-1]"
                                         class="ConfEntry-icon"></PackageIcon>
                        </div>
                        <ConfiguratorGallery
                            v-if="entry.image || entry.images?.length"
                            :image="entry.image"
                            :images="entry.images"
                            class="ConfEntry-image">
                        </ConfiguratorGallery>
                        <div class="ConfEntry-fieldWrapper" v-if="$route.name.includes('realization-conf')">
                            <template v-for="field of entry.fields">
                                <FieldsFactory f="field" v-for="subField of field.subFields" :field="subField" :packages="packages" class="ConfEntry-field" extended></FieldsFactory>
                            </template>
                        </div>
                        <div class="TipsAndSpecs">
                            <ItemTipsSpecs :tipsText="entry.tips" :specsText="entry.specs"></ItemTipsSpecs>
                        </div>
                        <CustomerNote v-if="entry.customerNotePrompt" :field="entry"></CustomerNote>
                        <ItemPrice v-if="result[entryKey]" :entry="result[entryKey]"
                                   class="ConfEntry-price"></ItemPrice>
                    </div>
                </EntryTypeFactory>
                <EntryComparison v-if="settings[currentStep].showComparison" :bundles="entries"
                                 :items="configuration.items"></EntryComparison>
                <StepBar
                    v-if="!settings[currentStep].showSummary"
                    :current="currentStep"
                    :settings="settings"
                    :total="total"
                    @stepChange="setStep($event)">
                </StepBar>
            </div>
        </div>
        <BaseSpinner v-if="formState.loading"></BaseSpinner>
    </div>
</template>

<script>
import {computed, watch, ref, reactive, provide} from 'vue';
import EntryTypeFactory from './Entry/EntryTypeFactory.vue';
import FieldsFactory from './Fields/FieldsFactory.vue';
import StepBar from './StepBar.vue';
import SummaryPanel from './SummaryPanel.vue';
import Breadcrumbs from "../components/Breadcrumbs.vue";
import ItemPrice from './ItemPrice.vue';
import PackageIcon from './PackageIcon.vue';
import ConfiguratorGallery from './ConfiguratorGallery.vue';
import {postConfiguration} from "../api/api";
import {convertToTextResult} from "../utils/utils";
import PackageIncludes from "./PackageIncludes";
import ItemTipsSpecs from "./ItemTipsSpecs";
import EntryComparison from "./EntryComparison";
import SectionNav from "./SectionNav";
import HelpBox from "./HelpBox.vue";
import CustomerNote from "./CustomerNote.vue";
import {formatPrice} from "../utils/utils";

export default {
    components: {
        SectionNav,
        EntryComparison,
        ItemTipsSpecs,
        PackageIncludes,
        EntryTypeFactory,
        FieldsFactory,
        StepBar,
        SummaryPanel,
        Breadcrumbs,
        ItemPrice,
        CustomerNote,
        ConfiguratorGallery,
        PackageIcon,
        HelpBox
    },
    props: {
        configuration: Object,
        configurationEntries: Object,
        steps: Array,
        settings: Array,
        result: Object,
        packages: Object,
        total: Object,
        gift: Object,
        id: String
    },
    setup(props) {
        const currentStep = ref(0);
        const entries = computed(() => props.steps[currentStep.value].entries);
        const singleEntry = computed(() => props.steps[currentStep.value].singleEntry ?? false);
        const formState = reactive({
            loading: false,
            sent: false,
            success: false,
            message: ''
        });

        if (entries.value.wholeType?.fields) {
            watch(entries.value.wholeType?.fields, fields => {
                if (fields[1].value) {
                    fields[0].value = true;
                    fields[0].disabled = true;
                } else {
                    fields[0].disabled = false;
                }
            })
        }

        if (singleEntry.value) {
            watch(entries.value, bundles => {
                if (Object.values(bundles).filter(bundle => bundle.selected).length > 1) {
                    document.querySelectorAll('input[type="radio"]').forEach(radio => {
                        radio.dispatchEvent(new Event('change'));
                    });
                } else {
                    const selectedFields = Object.values(bundles).find(bundle => bundle.selected)?.items?.map(item => item.key);
                    Object.entries(props.configurationEntries).forEach(([key, value]) => {
                        if (value.type === 'check')
                            value.selected = selectedFields && selectedFields.includes(key);
                    });
                }
            })
        }

        function setScrollPaddingTop() {
            setInterval(() => {
                let nav = document.querySelector('[data-section-nav]');
                let menu = document.getElementsByClassName('TheHeader-bottom')[0].offsetHeight;
                let menuTop = document.getElementsByClassName('TheHeader-top')[0].offsetHeight;

                let heightNav = 0;

                if (typeof (nav) != 'undefined' && nav != null) {
                    heightNav = nav.clientHeight;
                }
                if(window.pageYOffset < menuTop) {
                    heightNav += menuTop;
                }
                heightNav += menu;
                document.documentElement.style.setProperty('--navHeight', heightNav + 'px');

            }, 100);
        }

        setScrollPaddingTop();

        const setStep = step => {
            currentStep.value = step;
            window.scrollTo({top: 0});
            setScrollPaddingTop();
        }

        const formDataKeyPrefix = "userFormData/";
        const getSavedFormDataValue = key => localStorage.getItem(formDataKeyPrefix + key);
        const setSavedFormDataValue = (key, value) => localStorage.setItem(formDataKeyPrefix + key, value);
        const savedFormDataFields = [
            "billingFirstName",
            "billingLastName",
            "billingCompany",
            "billingCompanyId",
            "billingCompanyVatId",
            "billingAddress",
            "billingCity",
            "billingPostalCode",
            "billingPhone",
            "billingEmail",
            "customerFirstName",
            "customerLastName",
            "customerEmail",
            "customerPhone",
            "locationAddress",
            "locationCity",
            "locationPostalCode",
        ];

        const defaultUserData = {
            billingFirstName: '',
            billingLastName: '',
            billingCompany: '',
            billingCompanyId: '',
            billingCompanyVatId: '',
            billingAddress: '',
            billingCity: '',
            billingPostalCode: '',
            billingPhone: '',
            billingEmail: '',
            customerFirstName: '',
            customerLastName: '',
            customerEmail: '',
            customerPhone: '',
            locationAddress: '',
            locationCity: '',
            locationPostalCode: '',
            start: '',
            completion: '',
            assumedPrice: '',
            assumedPriceNote: '',
            file: null,
            file2: null,
            file3: null,
            question: '',
            rating: ''
        };
        for (const savedFormDataField of savedFormDataFields) {
            defaultUserData[savedFormDataField] = getSavedFormDataValue(savedFormDataField) ?? "";
        }
        const userFormData = reactive(props.configuration.userData ?? defaultUserData);

        const onFormSubmitted = (data, printOnly) => {
            for (const savedFormDataField of savedFormDataFields) {
                setSavedFormDataValue(savedFormDataField, userFormData[savedFormDataField]);
            }

            try {
                formState.loading = true;

                const formData = new FormData();
                formData.append('productType', props.id);

                // hack pro zjisteni celeho vybraneho produktu a balicku
                let productTypeText = props.configuration.title + ': ' + props.steps[0].title;
                if (props.configuration.hasOwnProperty('discountPackages')) {
                    let discountCode = props.configuration.discountPackages.selected;
                    props.configuration.discountPackages.fields.forEach((f) => {
                        if (f.id === discountCode) {
                            productTypeText += ', balíček ' + f.name;
                        }
                    });
                } else if (props.configuration.hasOwnProperty('packages')) {
                    let discountCode = props.configuration.packages.selected;
                    props.configuration.packages.fields.forEach((f) => {
                        if (f.id === discountCode) {
                            productTypeText += ', balíček ' + f.name;
                        }
                    });
                }

                formData.append('productTypeText', productTypeText);
                formData.append('originPath', location.pathname);
                if (printOnly) {
                    formData.append('printOnly', JSON.stringify(printOnly));
                }
                formData.append('configuration', convertToTextResult(props.result, props.configuration.discount.discount, props.gift, props.total.amountSaved));
                if (props.total.modifiers) {
                    formData.append('totalPriceModifiers', JSON.stringify(props.total.modifiers));
                }
                formData.append('totalBasePrice', props.total.totalPriceBase);
                formData.append('totalPrice', props.total.totalPrice);
                formData.append('totalPriceAddition', props.total.totalPriceAddition);
                formData.append('hasIndividualPrice', false);
                formData.append('sourceVatLevel', props.configuration.sourceVatLevel);
                formData.append('currentVatLevel', props.configuration.currentVatLevel);
                formData.append('configurationState', JSON.stringify({
                    ...props.configuration,
                    userData: userFormData
                }));

                for (let key in data) {
                    formData.append(key, data[key]);
                }

                console.log("onFormSubmitted", "formData", Object.fromEntries(formData));
                postConfiguration(formData).then(response => {
                    formState.success = response.success;
                    formState.message = response.message;
                    formState.sent = response.success;
                    if (response.redirect) {
                        window.open(response.redirect, '_blank');
                    }
                }).catch(e => {
                    formState.success = false;
                    formState.message = 'Něco se pokazilo, zkuste to prosím později.';
                    formState.sent = false;
                }).finally(() => {
                    formState.loading = false;
                });
            } catch (e) {
                console.error(e);
            }
        }

        provide('formState', formState);
        provide('userFormData', userFormData);
        provide('onFormSubmitted', onFormSubmitted);

        return {
            entries,
            setStep,
            currentStep,
            formState,
            userFormData,
            onFormSubmitted,
            formatPrice
        }
    }
}
</script>

<style lang="scss" scoped>
.is-chosen{
    visibility: hidden;
    position: fixed !important;
}
.Configurator {
    counter-reset: section;

    &-frame {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 5rem;
    }

    &-side {
        width: 22em;
        margin-right: 3em;
        position: relative;
        @media (max-width: 980px) {
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;
            z-index: 3;
        }
    }

    &-sideInner {
        position: sticky;
        top: 65px;

        .BaseAlert-minCena {
          display: block;
          @media (max-width: 980px) {
              display: none;
          }
        }
    }

    &-content {
        flex: 1;

        &Intro {
            margin: 0 0 3em;
        }
      .BaseAlert-minCena {
          display: none;
          @media (max-width: 980px) {
            display: block;
          }
      }
    }
}

.ConfEntry {
    $block: &;
    position: relative;
    &-icon {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;

        img {
            display: block;
            border-bottom-left-radius: 4px;
        }
    }

    &-content {
        display: flex;
        flex-wrap: wrap;
    }

    &-main {
        flex: 1;
    }

    &-image {
        width: 40%;
        margin-left: 1.5em;
        align-self: flex-start;
        @media (max-width: 580px) {
            width: 100%;
            margin: 2.4em 0 0;
        }
    }

    &-price {
        width: 100%;
    }

    &-field {
        border: 0;
        padding: 0;
        margin-bottom: 20px;

        &:empty {
            margin: 0;
        }

        &Wrapper:not(:empty) {
            margin-top: 20px;
            width: 100%;

            fieldset {
                margin-bottom: 32px;
            }
        }
    }

    &-fields {
        margin-top: 1.2rem;

        #{$block}-field {
            display: flex;
            flex-direction: column;
            gap: .75rem;
        }
    }

    &-gridView {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-gap: 2em;
        @media (max-width: 680px) {
            grid-template-columns: 1fr;
        }
    }

  .TipsAndSpecs {
    display: grid;
    grid-template-areas:
            "header  .  ."
            "summary summary summary";
    width: 100%;
  }

  .CustomerNote {
    width: 100%;
  }
}
</style>